(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shc-collection-navigation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-shc-collection-nav]').forEach(nav=>{
const design=nav.querySelector('#shc-design'),use=nav.querySelector('#shc-use');
const navigate=()=>{
const selected=design.options[design.selectedIndex],group=use.options[use.selectedIndex];
const offered=(selected.dataset.groups||'').split('|');
const tag=group.dataset.tag&&offered.includes(group.dataset.tag)?use.value:'';
const url=new URL(design.value+(tag?'/'+tag:''),location.origin);
const params=new URL(location.href).searchParams;
for(const key of ['sort_by','preview_theme_id'])if(params.has(key))url.searchParams.set(key,params.get(key));
location.assign(url.href);
};
design.addEventListener('change',navigate);use.addEventListener('change',navigate);
});
  } catch(e) { console.error(e); }
})();

})();
